import { createAsyncThunk } from '@reduxjs/toolkit';
import { AuthApi } from '../../../api/base/Auth';

export const fetchMediums = createAsyncThunk(
  'mediums/fetchMediums',
  async (): Promise<Array<any>> => {
    const response = await AuthApi.getMediums();
    return response.data.data;
  },
);
